module.exports = __webpack_public_path__ + "img/fi-street-food-600x395.0063dba4.jpg";